/* eslint-disable react/no-unescaped-entities */
import { Layout } from "components/common"
export default function Security() {
  return (
    <section className="max-w-screen-sm m-auto md:mt-4 p-4">
      <h1 className="m-auto font-semibold text-lg mb-4">CHÍNH SÁCH BẢO MẬT & ĐIỀU KHOẢN SỬ DỤNG</h1>
      <p className="mb-4 text-justify">
        Dịch vụ ON Live TV ("ON Live TV") là dịch vụ phát thanh, truyền hình - cung cấp video theo yêu cầu trên mạng
        Internet do Công ty Cổ phần Truyền hình Tương tác Việt Nam phát triển, được cấp phép Số 337/GP-BTTTT do Bộ Thông
        tin và Truyền thông cấp ngày 18/11/2024. ON Live TV cho phép người dùng có thể truy cập để xem các chương trình
        eSports, thể thao, giải trí và các nội dung video khác vào bất cứ thời gian nào người dùng mong muốn trên các
        thiết bị và/hoặc nền tảng khác nhau thông qua mạng Internet. Bằng việc sử dụng dịch vụ ON Live TV, Quý Khách
        hàng đồng ý và chấp thuận bị ràng buộc về pháp lý bởi các quyền và nghĩa vụ phát sinh theo quy định tại Quy chế
        này. ON Live TV có quyền thay đổi, chỉnh sửa, thêm hoặc lược bỏ bất kỳ phần nào trong Quy định và Điều kiện sử
        dụng, vào bất cứ lúc nào mà không cần thông báo trước. Quý khách vui lòng kiểm tra thường xuyên để cập nhật
        những thay đổi của ON Live TV.
      </p>
      <h2 className="font-semibold mb-2">1. KHAI BÁO KHI SỬ DỤNG</h2>
      <p className="mb-4 text-justify">
        Tất cả nội dung bạn xem được trên ON Live TV nhằm phục vụ nhu cầu thông tin của bạn và giúp bạn lựa chọn dịch
        vụ. Vì thế, bạn được sử dụng ON Live TV mà không cần cung cấp bất kỳ thông tin cá nhân nào. Tuy nhiên, trong một
        số trường hợp, khi liên quan đến việc đăng ký dịch vụ, chúng tôi có thể yêu cầu bạn cung cấp thông tin cá nhân.
      </p>
      <h2 className="font-semibold mb-2">2. THÔNG TIN CÁ NHÂN DO BẠN CUNG CẤP</h2>
      <p className="mb-4 text-justify">
        Khi bạn cung cấp các thông tin cần thiết, chúng tôi sẽ sử dụng chúng để đáp ứng yêu cầu của bạn, hoặc chúng tôi
        có thể liên lạc với bạn qua thư từ, email, tin nhắn hay điện thoại; hoặc tuân theo luật định hiện hành, sử dụng
        các phương tiện trên để giới thiệu đến bạn những sản phẩm, dịch vụ hay chương trình khuyến mãi mới từ ON Live
        TV. Khi cung cấp thông tin cho chúng tôi qua ON Live TV này, bạn hiểu rõ và chấp thuận việc thu thập, sử dụng và
        tiết lộ những thông tin cá nhân nêu trên cho một số mục đích được quy định trong trang này. Bạn hoàn toàn đồng ý
        và chấp thuận rằng những thông tin cá nhân bạn cung cấp khi sử dụng ON Live TV có thể được bảo lưu tại trụ sở
        hay của ON Live TV, có thể được lưu trữ tại một số máy chủ hiện có hay chưa biết trước cho mục đích vận hành và
        phát triển ON Live TV cũng như các dịch vụ của ON Live TV. Chúng tôi sẽ không cung cấp thông tin của bạn cho một
        bên thứ ba mà không được sự cho phép của bạn, trừ trường hợp bị pháp luật hiện hành bắt buộc hoặc trường hợp cần
        thiết để xử lý các vấn đề liên quan đến pháp luật. ON Live TV cam kết bảo vệ sự riêng tư của bạn, không mua bán
        thông tin cá nhân của bạn cho các công ty khác vì các mục đích khuyến mãi.
      </p>
      <h2 className="font-semibold mb-2">ON Live TV Sẽ Thu Thập Những Thông Tin Gì Và Sử Dụng Chúng Như Nào?</h2>
      Theo quy định của pháp luật Việt Nam và nhằm tối ưu hóa dịch vụ được cung cấp cho bạn, ON Live TV sẽ thu thập và
      lưu trữ các thông tin sau đây:
      <p className="mb-4 text-justify">
        <br />
        <br />
        <table>
          <thead>
            <tr>
              <th className="p-2">Thông tin cá nhân</th>
              <th className="p-2">Sử dụng</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-2">Tên đăng nhập</td>
              <td className="p-2">
                Chúng tôi sử dụng thông tin này để tạo tài khoản cho ON Live TV theo yêu cầu của bạn.
              </td>
            </tr>
            <tr>
              <td className="p-2">
                Thông tin kết nối xã hội: <br /> Facebook: Tên, ID Facebook, ảnh hồ sơ <br /> Google: Biệt hiệu, ảnh hồ
                sơ
              </td>
              <td className="p-2">
                Chúng tôi sử dụng thông tin này để: tạo tài khoản cho ON Live TV theo yêu cầu của bạn; chia sẻ ảnh trong
                ứng dụng trên Facebook theo yêu cầu của bạn.
              </td>
            </tr>
            <tr>
              <td className="p-2">Open ID đã tạo</td>
              <td className="p-2">
                Chúng tôi tạo dữ liệu này và sử dụng dữ liệu này để lưu trữ dữ liệu của bạn (lích sử xem và tiến trình)
                cùng với hồ sơ của bạn.
              </td>
            </tr>
            <tr>
              <td className="p-2">Địa chỉ IP</td>
              <td className="p-2">
                Chúng tôi sử dụng thông tin này để cải thiện các dịch vụ của mình, bao gồm cả chức năng của ON Live TV.
              </td>
            </tr>
            <tr>
              <td className="p-2">ID thiết bị, thông tin thiết bị</td>
              <td className="p-2">
                Chúng tôi sử dụng thông tin này: để cải thiện các dịch vụ của mình, bao gồm cả chức năng của ON Live TV;
                cho các mục đích bảo mật và xác minh; xác định và giải quyết các lỗi và đánh giá chức năng để tối ưu
                hóa; và để chống lại việc người dùng đăng ký nhiều tài khoản.
              </td>
            </tr>
            <tr>
              <td className="p-2">Thông tin liên quan đến bảo mật</td>
              <td className="p-2">
                Chúng tôi sử dụng thông tin này: cho mục đích bảo mật và xác minh; xác định và giải quyết các lỗi và
                đánh giá chức năng để tối ưu hóa hành động; giải quyết lỗi ứng dụng và tối ưu hóa khả năng tương thích
                của thiết bị với ứng dụng; và để chống lại việc người dùng đăng ký nhiều tài khoản.
              </td>
            </tr>
            <tr>
              <td className="p-2">Thông tin khảo sát và nội dung của các câu trả lời khảo sát</td>
              <td className="p-2">Chúng tôi sử dụng thông tin này để cải thiện dịch vụ của mình.</td>
            </tr>
          </tbody>
        </table>
        <br />
        Theo quy định của pháp luật Việt Nam, toàn bộ thông tin cá nhân và dữ liệu của bạn sẽ được lưu trữ tối thiểu hai
        (2) năm kể từ thời điểm bạn cung cấp thông tin và/hoặc tạo ra dữ liệu.
        <br />
        <br /> ON Live TV có quyền sử dụng các thông tin nêu trên để gửi đến bạn các tin nhắn, thư điện tử (email), gọi
        điện thoại và/hoặc liên hệ với bạn theo bất kỳ cách thức nào mà ON Live TV lựa chọn sử dụng nhằm:
        <br />- Hỗ trợ, cung ứng các dịch vụ tốt nhất cho bạn <br />- Gửi đến bạn các thông tin, nội dung nhằm mục đích
        quảng cáo dịch vụ của ON Live TV <br />- Phân tích, đo lường hiệu quả các dịch vụ mà bạn sử dụng <br />- Liên hệ
        trực tiếp với bạn để nhằm mục đích chăm sóc khách hàng, xác thực thông tin và các mục đích khác. <br /> <br />
        ON Live TV sẽ cung cấp, chia sẻ các thông tin cá nhân, dữ liệu và/hoặc các thông tin khác của bạn mà ON Live TV
        lưu trữ trong các trường hợp sau đây:
        <br />- Được sự đồng ý của bạn. <br />- Theo yêu cầu của Tòa án và/hoặc Cơ quan Nhà nước có thẩm quyền.
        <br /> <br />
        ON Live TV sẽ thực hiện các biện pháp kỹ thuật cần thiết để bảo mật thông tin của bạn, bao gồm không giới hạn ở
        việc (I) mã hóa thông tin theo tiêu chuẩn phù hợp, (II) thiết lập các hệ thống tường lửa để ngăn chặn việc xâm
        nhập trái phép, (III) sử dụng dịch vụ máy chủ, chỗ đặt máy chủ tại các đơn vị, doanh nghiệp có tiêu chuẩn bảo
        mật cao.
      </p>
      <h2 className="font-semibold mb-2">3. CUNG CẤP CHO CÁC ĐƠN VỊ KHÁC</h2>
      <p className="mb-4 text-justify">
        Chúng tôi có thể sử dụng một số đơn vị khác để cung cấp sản phẩm hay dịch vụ cho bạn. Chúng tôi cũng cần trao
        đổi thông tin cá nhân của bạn đến các đơn vị này để họ hoàn thành yêu cầu của bạn. Những đơn vị này cũng không
        được phép sử dụng thông tin cá nhân của bạn cho các mục đích khác và chúng tôi đồng thời yêu cầu họ tuân theo
        quy định bảo mật khi tiến hành cung cấp dịch vụ.
      </p>
      <h2 className="font-semibold mb-2">4. GHI NHẬN THÔNG TIN TRÌNH DUYỆT</h2>
      <p className="mb-4 text-justify">
        Đôi khi, thông tin có thể được đưa vào máy tính của bạn để giúp chúng tôi nâng cấp ON Live TV hay cải thiện chất
        lượng dịch vụ cho bạn. Những thông tin này thường được biết đến dưới dạng các “cookies” mà nhiều ON Live TV hiện
        cũng đang sử dụng. “Cookies” là những mẩu thông tin lưu trữ trong đĩa cứng hay trình duyệt trên máy tính của
        bạn, không phải trên ON Live TV. Chúng cho phép thu thập một số thông tin về máy tính của bạn như địa chỉ IP, hệ
        điều hành, chế độ trình duyệt và địa chỉ của các ON Live TV liên quan. Nếu bạn không muốn nhận các cookies này,
        hoặc muốn được thông báo khi các cookies này được đặt vào, bạn có thể cài đặt chế độ trình duyệt của bạn thực
        hiện điều này nếu trình duyệt của bạn hỗ trợ. Vui lòng lưu ý, nếu bạn tắt chế độ nhận cookies, bạn sẽ không thể
        truy cập hay sử dụng một số tiện ích trên ON Live TV mà không được xác định trước. Chúng tôi không cố ý hạn chế
        việc sử dụng của bạn trong tình huống này, đây chỉ là giới hạn trong việc lập trình và xây dựng ON Live TV.
      </p>
      <h2 className="font-semibold mb-2">5. AN TOÀN THÔNG TIN</h2>
      <p className="mb-2 text-justify">
        Khi lập trình ON Live TV, chúng tôi có thể đặt những luật định hợp lý mang tính thương mại để ngăn chặn hành vi
        truy cập bất hợp pháp và việc sử dụng không thích đáng các thông tin cá nhân của bạn đã gửi cho ON Live TV thông
        qua việc sử dụng ON Live TV này. Vì luôn có những rủi ro liên quan đến vấn đề cung cấp dữ liệu cá nhân, cho dù
        là cung cấp trực tiếp, qua điện thoại hay qua mạng internet, hay qua các phương tiện kỹ thuật khác; và không có
        hệ thống kỹ thuật nào an toàn tuyệt đối hay chống được tất cả các “hacker” và “tamper” (người xâm nhập trái phép
        để lục lọi thông tin), ON Live TV luôn nỗ lực tiến hành những biện pháp đề phòng thích hợp đối với từng đặc tính
        của thông tin để ngăn chặn và giảm thiểu tối đa các rủi ro có thể khi bạn sử dụng ON Live TV này.
      </p>
      <h2 className="font-semibold mb-2">GIỚI HẠN THIẾT BỊ TƯƠNG THÍCH</h2>
      <p className="mb-4 text-justify">
        Hiệu năng của ứng dụng ON Live TV phụ thuộc vào mẫu điện thoại, máy tính bảng, thiết bị thông minh Android mà
        bạn sử dụng, bên cạnh đó là hệ điều hành, phiên bản hệ điều hành, ngôn ngữ, nhà mạng của bạn. Để tìm hiểu hệ
        điều hành được ứng dụng ON Live TV hỗ trợ vui lòng xem dưới đây:
        <br /> <br />
        iOS (Apple Smartphone): iOS 12.0 hoặc mới hơn.
        <br /> <br />
        Android (Android Smartphone/Tablet): Android 7 hoặc mới hơn.
        <br /> <br />
        iPadOS (Apple iPad): iPadOS 10.0 hoặc mới hơn.
        <br /> <br />
        Trình duyệt web: Chrome, Edge, Firefox.
        <br /> <br />
        ON Live TV không giải quyết các khiếu nại liên quan đến hiệu năng hoặc nội dung cung cấp của ứng dụng trên các
        thiết bị đã rooted, jailbreak, hack.
      </p>
      <h2 className="font-semibold mb-2">6. THÔNG TIN QUA EMAIL</h2>
      <p className="mb-4 text-justify">
        Khi bạn đăng ký dịch vụ, địa chỉ email của bạn cung cấp sẽ dùng làm công cụ trao đổi thông tin với bạn. Trước
        hết bạn hãy chắc rằng bạn cung cấp địa chỉ email hữu dụng đối với bạn trong suốt quá trình sử dụng dịch vụ.
        Chúng tôi có thể gửi những thông tin bí mật qua email hay tiếp nhận yêu cầu hỗ trợ của bạn. Trong trường hợp bạn
        không còn sử dụng email đã cung cấp, bạn phải báo cho chúng tôi để về việc thay đổi này. Để bảo vệ bạn, ON Live
        TV có thể tạm thời ngừng tiếp nhận yêu cầu qua email bạn đã cung cấp nếu nhận thấy có sự gian lận hoặc thông tin
        bất thường - cho đến khi chúng tôi liên hệ được với bạn để xác nhận.
      </p>
      <h2 className="font-semibold mb-2">7. ĐIỀU CHỈNH THÔNG TIN</h2>
      <p className="mb-4 text-justify">
        ON Live TV sẽ chủ động hoặc theo yêu cầu của bạn bổ sung, hiệu chỉnh hay tẩy xóa các dữ liệu thông tin cá nhân
        không chính xác, không đầy đủ hoặc không cập nhật khi bạn còn liên kết với hoạt động của chúng tôi.
      </p>
      <h2 className="font-semibold mb-2">8. LIÊN KẾT NGOÀI ON Live TV</h2>
      <p className="mb-4 text-justify">
        ON Live TV này có thể chứa các đường liên kết đến các ON Live TV khác được đặt vào nhằm mục đích giới thiệu hoặc
        bổ sung thông tin liên quan để bạn tham khảo. ON Live TV không chịu trách nhiệm về nội dung hay các hành vi của
        bất kỳ ON Live TV nào khác.
      </p>
      <h2 className="font-semibold mb-2">9. THAY ĐỔI QUY ĐỊNH</h2>
      <p className="mb-4 text-justify">
        ON Live TV có thể thay đổi quy định này một cách không thường xuyên, bao gồm việc bổ sung, loại bỏ một phần nội
        dung hoặc tạm ngưng ON Live TV mà không cần báo trước. Tuy nhiên, nếu quy định này được thay đổi theo hướng có
        thể gây bất lợi cho bạn, ON Live TV sẽ cố gắng thông báo về sự thay đổi qua email bạn đã cung cấp hoặc ngay trên
        trang chủ.
      </p>
      <h2 className="font-semibold mb-2">10. XÓA THÔNG TIN VÀ TÀI KHOẢN TRÊN HỆ THỐNG</h2>
      <p className="mb-4 text-justify">
        10.1. Quyền xóa thông tin tài khoản:
        <br /> <br />
        10.1.1. Bạn có thể tự xóa/yêu cầu xóa thông tin của mình đã đăng ký với ON Live TV hoặc xóa tài khoản của mình
        bằng cách các cách thức như sau: <br /> - Thực hiện thao tác xóa tài khoản trên thiết bị đã đăng nhập tài khoản
        muốn xóa, lưu ý: khi bạn thực hiện "Xác nhận" đồng nghĩa với việc đồng ý với các điều khoản trong việc xóa tài
        khoản đã được nêu. <br /> - Gửi yêu cầu bằng văn bản hoặc email cho bộ phận CSKH của chúng tôi tại địa chỉ
        hotro@onlive.vn và trực tiếp qua hotline 1900 866 666 (nhánh 2), và chúng tôi sẽ xử lý yêu cầu dựa theo các quy
        định Chính Sách Bảo Mật này và các nghĩa vụ của chúng tôi được quy định bởi pháp luật.
        <br /> <br />
        10.1.2. Việc bạn yêu cầu xóa thông tin cũng đồng nghĩa với việc chúng tôi sẽ không thể tiếp tục cung cấp dịch vụ
        cho bạn và chúng tôi có thể cần phải chấm dứt quan hệ hiện tại của bạn và/hoặc hợp đồng của bạn với chúng tôi và
        không phải bồi thường bất kỳ tổn thất nào cho bạn.
        <br /> <br />
        10.2. Quyền yêu cầu truy cập và điều chỉnh thông tin
        <br /> <br />
        10.2.1. Nếu bạn đã đăng ký một tài khoản với chúng tôi, bạn có thể truy cập và chỉnh sửa dữ liệu cá nhân của bạn
        mà chúng tôi đang lưu giữ thông qua Thiết lập tài khoản. Nếu bạn chưa đăng ký tài khoản với chúng tôi, cá nhân
        bạn có thể yêu cầu truy cập và chỉnh sửa dữ liệu cá nhân của bạn mà chúng tôi đang lưu giữ hoặc kiểm soát bằng
        cách gửi yêu cầu bằng văn bản cho chúng tôi. Chúng tôi sẽ cần đầy đủ thông tin từ bạn để xác định danh tính của
        bạn cũng như bản chất yêu cầu của bạn để xử lý cho bạn. Do đó, vui lòng gửi yêu cầu bằng văn bản của bạn cho
        chúng tôi thông qua email hotro@onlive.vn.
        <br /> <br />
        10.2.2. Chúng tôi bảo lưu quyền từ chối sửa dữ liệu cá nhân của bạn theo các quy định của pháp luật về bảo vệ bí
        mật thông tin cá nhân, trường hợp các điều luật đó yêu cầu và/hoặc cho phép một tổ chức từ chối sửa dữ liệu cá
        nhân trong các trường hợp như thế.
      </p>
    </section>
  )
}
